// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--SzRPG","name":"_32bbee5fda--name--VRcjM","name--hovered":"_32bbee5fda--name--hovered--UqJQD"};